/* Shared storefront API. Customer identity is verified by Shopify's signed app proxy on the server. */
(function () {
  'use strict';
  const node = document.getElementById('sk-quotation-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const candidate = String(config.proxyBase || '/apps/quotationlist').replace(/\/+$/, '');
  config.proxyBase = /^\/apps\/[a-zA-Z0-9/_-]+$/.test(candidate) ? candidate : '/apps/quotationlist';
  const root = String(config.root || '/').replace(/\/$/, '');
  const files = new Map();
  const api = window.SkQuotation = {
    config,
    path(path) { return config.proxyBase + '/' + String(path || '').replace(/^\/+/, ''); },
    shopPath(path) { return root + '/' + String(path || '').replace(/^\/+/, ''); },
    login() {
      const loginUrl = new URL(config.storefrontLoginUrl || config.loginUrl || api.shopPath('account/login'), window.location.origin);
      if (config.storefrontLoginUrl) {
        let returnTo = '/';
        try {
          const decodedPath = decodeURIComponent(window.location.pathname);
          if (/^\/(?![\/\\])/.test(decodedPath) && !/[\\\u0000-\u001f\u007f]/.test(decodedPath)) {
            returnTo = window.location.pathname + window.location.search;
          }
        } catch (_) { /* An invalid return path falls back to the storefront root. */ }
        // Shopify's storefront route can already contain locale, UI and return parameters.
        loginUrl.searchParams.set('return_to', returnTo);
      }
      // Without the storefront route, retain Shopify's account-login destination.
      window.location.assign(loginUrl.href);
    },
    async request(path, options = {}) {
      const response = await fetch(api.path(path), { credentials: 'same-origin', ...options });
      const text = await response.text();
      let data;
      try { data = JSON.parse(text); } catch (_) { throw new Error('Der Dienst ist gerade nicht erreichbar. Bitte versuchen Sie es erneut.'); }
      if (!response.ok || data.success === false || data.error) {
        const error = new Error(data.message || (typeof data.error === 'string' ? data.error : '') || 'Die Anfrage konnte nicht verarbeitet werden.');
        error.status = response.status;
        error.data = data;
        throw error;
      }
      return data;
    },
async addToBasket(items, note = '') {
  if (!config.customerId) {
    api.login();
    return null;
  }

  const body = new URLSearchParams({
    customerId: config.customerId,
    note,
    idempotency_key: crypto.randomUUID()
  });

  items.forEach((item, index) => {
    body.set(`basketItems[${index}][id]`, String(item.id || item.variant_id));
    body.set(`basketItems[${index}][quantity]`, String(item.quantity || 1));
  });

  const response = await fetch(api.path('Basketlist/'), {
    method: 'POST',
    credentials: 'same-origin',
    body
  });

  const text = await response.text();

  let data = null;
  try {
    data = JSON.parse(text);
  } catch (_) {}

if (!response.ok) {
  throw new Error(
    (data && (data.message || data.error)) ||
    ('Serverfehler ' + response.status + ' beim Speichern der Angebotsanfrage.')
  );
}

  if (!data) {
    throw new Error(
      'Die Speicherung der Anfrage konnte nicht bestätigt werden. Ihr Warenkorb bleibt erhalten.'
    );
  }

  if (data.success !== true || Number(data.code) !== 100) {
    throw new Error(
      data.message ||
      'Die Speicherung der Anfrage konnte nicht bestätigt werden. Ihr Warenkorb bleibt erhalten.'
    );
  }

  return data;
},
    rememberFiles(value) {
      if (!value || typeof value !== 'object') return;
      const path = value.path || value.image_path || value.image;
      if (typeof path === 'string' && (value.url || value.thumbnail_url)) files.set(api.fileKey(path), value);
      if (value.thumbnail_path && value.thumbnail_url) files.set(api.fileKey(value.thumbnail_path), { url: value.thumbnail_url, thumbnail_url: value.thumbnail_url });
      Object.values(value).forEach(child => { if (child && typeof child === 'object') api.rememberFiles(child); });
    },
    fileKey(path) {
      const raw = String(path || '').replace(/^\/+/, '');
      if (/^https?:/i.test(raw)) return raw;
      return raw.replace(/^.*?Basketlist\//, '');
    },
    fileUrl(path, thumbnail = false) {
      const raw = String(path || '');
      const known = files.get(api.fileKey(raw));
      if (known) return thumbnail ? (known.thumbnail_url || known.url || api.path('Basketlist/' + api.fileKey(raw))) : (known.url || api.path('Basketlist/' + api.fileKey(raw)));
      if (/^https?:\/\//i.test(raw) || raw.startsWith(config.proxyBase + '/')) return raw;
      return api.path('Basketlist/' + api.fileKey(raw));
    },
    notice(message, error = false) {
      let element = document.querySelector('[data-sk-global-notice]');
      if (!element) {
        element = document.createElement('div'); element.dataset.skGlobalNotice = ''; element.className = 'sk-global-notice';
        element.setAttribute('role', 'status'); document.body.appendChild(element);
      }
      element.textContent = message; element.hidden = false; element.classList.toggle('is-error', error);
      clearTimeout(api.noticeTimer); api.noticeTimer = setTimeout(() => { element.hidden = true; }, 8000);
    },
    initializeLegacy() {
      if (!window.jQuery) return;
      window.skjQ = window.jQuery; window.$ = window.jQuery;
      if (!api.jqueryBound) {
        api.jqueryBound = true;
        window.jQuery.ajaxPrefilter(function (options, original) {
          if (!String(options.url || '').startsWith(config.proxyBase + '/')) return;
          const previous = options.success;
          options.success = function (data, ...args) { api.rememberFiles(data); if (typeof previous === 'function') return previous.call(this, data, ...args); };
          const failed = options.error;
          options.error = function (xhr, ...args) {
            if (xhr.status === 401) api.notice('Bitte melden Sie sich erneut an, um Ihre Anfrage zu bearbeiten.', true);
            else if (!failed) api.notice('Die Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.', true);
            if (typeof failed === 'function') return failed.call(this, xhr, ...args);
          };
        });
      }
      // These are our static Liquid-rendered page scripts. Activating them in order
      // after deferred dependencies avoids parser-blocking jQuery and initialization races.
      document.querySelectorAll('.sk-quotation-page script[data-sk-page-script]').forEach(source => {
        if (source.dataset.skActivated) return;
        source.dataset.skActivated = 'true';
        const script = document.createElement('script');
        script.textContent = source.textContent;
        source.insertAdjacentElement('afterend', script);
      });
      const tasks = window.skLoad.splice(0);
      tasks.forEach(task => { try { task(); } catch (error) { console.error('Quotation initialization failed', error); api.notice('Die Anfrage konnte nicht vollständig geladen werden. Bitte Seite neu laden.', true); } });
    }
  };
  window.skLoad = window.skLoad || [];
  window.sk = window.sk || {};
  window.sk.log = window.sk.log || function () {};
  window.customerId = config.customerId;
  document.addEventListener('DOMContentLoaded', () => api.initializeLegacy(), { once: true });
})();
